<template>

<div class="row">

<img :src="'./static/img/logo.png'" class="img-responsive center-block" width="650" style="margin-top:150px;margin-bottom:100px;">

<h1>CHOOSE<br>YOUR KITCHEN</h1>
<router-link :to="'/Cortina'">
<img :src="'./static/img/cortina.jpg'" class="img-responsive center-block" width="250" style="margin-top:100px;margin-bottom:20px;">
</router-link>
<router-link :to="'/Frendel'">
<img :src="'./static/img/frendel.jpg'" class="img-responsive center-block" width="250" style="margin-top:100px;">
</router-link>
</div>

</template>

<script>

export default {
  name: 'Landing',
  data () {
    return {
      msg: 'Welcome to Landing page!'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  color:#d9272e;
  font-size: 100px;
  letter-spacing: 3px;
}
h2{
  font-family: 'ralewaysemibold';
  font-size: 40px;
  font-style: italic;
  line-height: 50px;
  margin:70px;
}

h3{
  color:#d9272e;
  font-size: 40pt;
  font-weight: 100;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Categories.vue